export const BARCLUB_ADD_REQUEST = "BARCLUB_ADD_REQUEST";
export const BARCLUB_ADD_SUCCESS = "BARCLUB_ADD_SUCCESS";
export const BARCLUB_ADD_FAILURE = "BARCLUB_ADD_FAILURE";

export const BARCLUB_EDIT_REQUEST = "BARCLUB_EDIT_REQUEST";
export const BARCLUB_EDIT_SUCCESS = "BARCLUB_EDIT_SUCCESS";
export const BARCLUB_EDIT_FAILURE = "BARCLUB_EDIT_FAILURE";

export const BARCLUB_VIEW_REQUEST = "BARCLUB_VIEW_REQUEST";
export const BARCLUB_VIEW_SUCCESS = "BARCLUB_VIEW_SUCCESS";
export const BARCLUB_VIEW_FAILURE = "BARCLUB_VIEW_FAILURE";

export const BARCLUB_VIEW_ALL_REQUEST = "BARCLUB_VIEW_ALL_REQUEST";
export const BARCLUB_VIEW_ALL_SUCCESS = "BARCLUB_VIEW_ALL_SUCCESS";
export const BARCLUB_VIEW_ALL_FAILURE = "BARCLUB_VIEW_ALL_FAILURE";

export const BARCLUB_SEARCH_REQUEST = "BARCLUB_SEARCH_REQUEST";
export const BARCLUB_SEARCH_SUCCESS = "BARCLUB_SEARCH_SUCCESS";
export const BARCLUB_SEARCH_FAILURE = "BARCLUB_SEARCH_FAILURE";

export const BARCLUB_VIEW_ALL_BY_WHOLESALERID_REQUEST = "BARCLUB_VIEW_ALL_BY_WHOLESALERID_REQUEST";
export const BARCLUB_VIEW_ALL_BY_WHOLESALERID_SUCCESS = "BARCLUB_VIEW_ALL_BY_WHOLESALERID_SUCCESS";
export const BARCLUB_VIEW_ALL_BY_WHOLESALERID_FAILURE = "BARCLUB_VIEW_ALL_BY_WHOLESALERID_FAILURE";

export const BARCLUB_WHOLESALERID_SEARCH_REQUEST = "BARCLUB_WHOLESALERID_SEARCH_REQUEST";
export const BARCLUB_WHOLESALERID_SEARCH_SUCCESS = "BARCLUB_WHOLESALERID_SEARCH_SUCCESS";
export const BARCLUBL_WHOLESALERID_SEARCH_FAILURE = "BARCLUB_WHOLESALERID_SEARCH_FAILURE";

export const BARCLUB_DELETE_REQUEST = "BARCLUB_DELETE_REQUEST";
export const BARCLUB_DELETE_SUCCESS = "BARCLUB_DELETE_SUCCESS";
export const BARCLUB_DELETE_FAILURE = "BARCLUB_DELETE_FAILURE";

export const BARCLUB_RESET_STATE = "BARCLUB_RESET_STATE";
